<template>
  <section class="content">
   <div id="overlay"  v-if="loading">
     <div class="spinner"></div>
     <br/>
      <h4>Loading...</h4>
    </div>
      <div class="box box-info">
        <form class="form-horizontal">
          <div class="box-body">
            <div class="p-fluid p-formgrid p-grid p-mt-2">
              <div  class="p-field p-col-12 p-md-2">
                <label for="purchaseSalesDate">Pickup Date</label>
                <date-picker ref="purchaseSalesDate" v-model="purchaseSalesDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" ref="tran" type="text" v-else class="nepali-calendar form-control" id="purchaseSalesDate" v-model="purchaseSalesDate"/>
              </div>

              <!-- <div class="col-md-2">
                <label for="orderNo">Delivery Code</label>
                <input type="text" class="form-control" id="orderNo" disabled v-model="orderCode"/>
              </div> -->
<!--              <div class="col-md-2">-->
<!--                <label for="referenceNumber" >Ref No</label>-->
<!--                <input type="text" class="form-control" id="refNO"  v-model="referenceNumber"/>-->
<!--              </div>-->

              <div class="p-field p-col-12 p-md-3">
               <label for="warehouse">Store</label>
                <Dropdown
                 v-if="!setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :showClear="true"
                />
                <Dropdown
                 v-if="setWarehouseData"
                  v-model="warehouseId"
                  :options="warehouseLists"
                  optionLabel="name"
                  id="warehouse"
                  class="dropDown"
                  :filter="true"
                  placeholder="Select warehouse"
                  :disabled="true"
                />
              </div>
              <div class="p-field p-col-12 p-md-2 align-self-end">
                <wearhouseDialog v-tooltip.top="'Add Warehouse'" @set_data_warehouse="set_data_warehouse"/>
              </div>
                <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Bill Amount</label>
               <InputNumber  id="minmaxfraction" onfocus="if (this.value === '0.00')
                                this.value = ''" v-model="billAmount"  :minFractionDigits="2" :maxFracionDigits="4" />
              </div>

            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Customer Name</label>
                  <InputText class="form-control" ref="orderNo"  v-model="customerName"/>
              </div>
                <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Contact No</label>
                  <InputText @keypress="isNumber($event)" class="form-control" id="primContact"  v-model="contactNumber"/>
              </div>

                <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Secondary No</label>
                  <InputText @keypress="isNumber($event)" class="form-control" id="secContact"  v-model="secondaryContactNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Address</label>
                  <InputText class="form-control" id="orderNo"  v-model="address"/>
              </div>
            </div>

            <div class="p-fluid p-formgrid p-grid">
                 <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Receiver Name</label>
               <InputText class="form-control" id="orderNo"  v-model="receiverName"/>
              </div>
                <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Contact No</label>
               <InputText @keypress="isNumber($event)" class="form-control" id="primContact"  v-model="receiverContactNumber"/>
              </div>

                <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Secondary No</label>
               <InputText @keypress="isNumber($event)" class="form-control" id="secContact"  v-model="receiverSecondaryContactNumber"/>
              </div>
              <div class="p-field p-col-12 p-md-3">
                  <label for="cus">Address</label>
               <InputText class="form-control" id="orderNo"  v-model="receiverAddress"/>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="remarks">Remarks</label>
                <TextArea cols="6" rows="15" v-model="remarks" id="remarks" class="textareaBox p-inputtext" />
              </div>
            </div>
          </div>
        </form>
        <div class="box-footer container-fluid">
          <div class="btnWrapper">
            <div class="btnItm">
              <a class="p-button p-component p-button-outlined text-center" download="deliveryUplaodFormat.xlsx" href="../../../../static/excelFormat/upload format-BlueWagon.xlsx">Download format</a>
            </div>
            <div class="btnItm">
              <Button label="Reset" icon="pi pi-refresh" class=" p-button p-component p-button-outlined p-button-danger" @click="reset" v-if="this.deliveryEntry==undefined">Reset</Button>
              <Button label="Cancel" class="p-button-raised p-button-rounded" v-if="this.deliveryEntry != undefined" @click="goBack()">Cancel</Button>
            </div>
            <div class="btnItm -excelUpload">
              <label for="imageUpload" class="p-button p-component p-button-raised p-button-info">Excel Upload </label>
              <input id="imageUpload" type="file"  @change="onFileSelect" multiple />
            </div>
            <div class="btnItm">
              <Button class="p-button p-component" label="Upload" @click.prevent="uploadExcel"></Button>
            </div>
            <div class="btnItm">
              <Button icon="pi pi-save" class="p-button-raised p-button-success" :label="!this.editing ? 'Save': 'Update'"  @click.prevent="saveDeliveryOrder"></Button>
            </div>
            <div class="btnItm">
              <a class="btn btn-default pull-right" v-if="this.saved"><i class="fa fa-print"></i> Print</a>
            </div>
            <div class="btnItm">
              <Button class="p-button-raised" style="margin-right:5px;" v-if="this.saved">
                <i class="fa fa-download"></i> Generate PDF
              </Button>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import wearhouseDialog from '../warehouseDialog/warehouseDialog'
import FileUpload from 'primevue/fileupload'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext/InputText'

export default {
  name: 'deliveryEntry',
  props: ['deliveryEntry'],
  data() {
    return {
      warehouseId: '',
      assignedTo: '',
      deliveryChargeAmount: 0,
      billAmount: 0,
      address: '',
      referenceNumber: '',
      orderStatus: '',
      customerName: '',
      paymentStatus: '',
      englishDateEnabled: true,
      orderMessage: '',
      purchaseSalesDate: null,
      contactNumber: '',
      secondaryContactNumber: '',
      shipDate: null,
      editDTO: false,
      editing: false,
      inventoryOutheaderId: null,
      index: null,
      orderNo: null,
      orderCode: '',
      loading: false,
      id: null,
      images: [],
      filteredItems: null,
      saved: false,
      remarks: '',
      assignToUserList: [],
      setWarehouseData: false,
      receiverName: '',
      receiverContactNumber: '',
      receiverSecondaryContactNumber: '',
      receiverAddress: '',
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {label: 'Received By Rider', value: 'ReceivedByRider'},
       {label: 'Received By Store', value: 'ReceivedByStore'}, {label: 'Assigned To Rider', value: 'AssignedToRider'}, {label: 'Completed', value: 'Completed'}, {label: 'Cancelled', value: 'Cancelled'}],
      statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'Unpaid', value: 'UnPaid'}, {label: 'Half Payment', value: 'HalfPayment'}]
    }
  },
  computed: {
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    },
    userLists() {
      return this.$store.state.user.userLists
    }
  },
  mounted() {
    this.warehouseList()
    this.userList()
    // this.maxDeliveryNo()
    this.setWarehouse()
    if (this.deliveryEntry !== undefined) {
      this.editSales()
    }
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.deliveryEntry === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async userList() {
      let response = await this.$store.dispatch('loadUser')
      this.assignToUserList = response.data.data
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      }
    },
    // async maxDeliveryNo() {
    //   let response = await this.$store.dispatch('maxDeliveryNo')
    //   if (this.deliveryEntry === undefined) {
    //     this.orderNo = response.data.data
    //     this.orderCode = 'BW' + response.data.data
    //     this.orderMessage = response.data.message
    //     this.narration = response.data.message + '- ' + response.data.data
    //   } else {
    //     this.orderNo = this.deliveryEntry.orderNo
    //     this.orderMessage = this.deliveryEntry.remarks
    //   }
    // },
    async uploadExcel() {
      let response = ''
      let excelUpload = {
        customerName: 'ssss'
      }
      const formData = new FormData()
      formData.append('excelUpload', JSON.stringify(excelUpload))
      for (let i = 0; i < this.images.length; i++) {
        formData.append('files', this.images[i])
      }
      if (this.deliveryEntry === undefined) {
        this.loading = true
        response = await this.$store.dispatch('uploadExcelDeiveryDetails', formData)
        this.loading = false
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.setWarehouse()
        // await this.maxDeliveryNo()
        this.reset()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    async saveDeliveryOrder() {
      if (this.purchaseSalesDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 10000})
        return
      }
      let response = ''
      let delivery = {
        orderNo: this.orderNo,
        warehouseId: this.warehouseId.id,
        purchaseSalesDate: this.purchaseSalesDate,
        purchaseSalesDateNepali: this.purchaseSalesDate,
        referenceNumber: this.referenceNumber,
        fiscalYearId: this.$store.state.fyId,
        remarks: this.remarks,
        id: this.inventoryOutheaderId,
        shipDate: this.shipDate,
        billAmount: this.billAmount,
        deliveryChargeAmount: this.deliveryChargeAmount,
        customerName: this.customerName,
        address: this.address,
        primaryContact: this.contactNumber,
        secondaryContact: this.secondaryContactNumber,
        shippingAddress: this.address,
        orderStatus: this.orderStatus,
        paymentStatus: this.paymentStatus,
        assignedTo: this.assignedTo.id,
        receiverName: this.receiverName,
        receiverAddress: this.receiverAddress,
        receiverPrimaryContact: this.receiverContactNumber,
        receiverSecondaryContact: this.receiverSecondaryContactNumber,
        orderCode: this.orderCode
      }
      if (this.warehouseId === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select store!', life: 10000})
        return
      }
      if (this.deliveryEntry === undefined) {
        this.loading = true
        response = await this.$store.dispatch('addDelivery', delivery)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateSalesOrder', delivery)
        this.loading = false
        this.$router.back()
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.setWarehouse()
        // await this.maxDeliveryNo()
        this.reset()
        this.setWarehouse()
        this.focusAfterSave()
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    onFileSelect(event) {
      let selectedFile = Array.prototype.slice.call(event.target.files)
      selectedFile.forEach(f => {
        this.images.push(f)
        let reader = new FileReader()
        reader.onload = (e) => {
          this.url.push(e.target.result)
        }
        reader.readAsDataURL(f)
      })
    },
    set_data_warehouse(data) {
      this.warehouseId = data
    },
    editSales() {
      this.editing = true
      // this.purchaseSalesDate = this.salesOrder.purchaseSalesDate
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.purchaseSalesDate = this.deliveryEntry.purchaseSalesDateNepali
        this.shipDate = this.deliveryEntry.shipDateNepali
      } else {
        this.purchaseSalesDate = this.deliveryEntry.purchaseSalesDate
        this.shipDate = this.deliveryEntry.shipDate
      }
      this.referenceNumber = this.deliveryEntry.referenceNumber
      this.narration = this.deliveryEntry.remarks
      this.warehouseId = this.deliveryEntry.warehouse
      this.inventoryOutheaderId = this.deliveryEntry.id
    },
    deleteItemFromDTO(data, id) {
      if (this.editing && data.id !== null) {
        this.inventoryInOutDetailDeleteList.push({...data})
      }
      this.inventoryInOutDetailList.splice(id, 1)
    },
    setNepaliDate() {
      if (this.deliveryEntry === undefined) {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        // this.shipDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      // this.shipDate = new Date().toISOString().slice(0, 10)
    },
    // exportCSV() {
    //   axios({
    //     url: globalKey + '/fileDownload/excelDownloadFormatForDelivery',
    //     method: 'get',
    //     headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
    //     responseType: 'blob'
    //   }).then((response) => {
    //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
    //     const link = document.createElement('a')
    //     const contentDisposition = response.headers['content-disposition']
    //     let fileName = 'vendorDeliveryReport.xlsx'
    //     if (contentDisposition) {
    //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
    //       if (fileNameMatch.length === 2) {
    //         fileName = fileNameMatch[1]
    //       }
    //     }
    //     link.href = url
    //     link.setAttribute('download', fileName)
    //     document.body.appendChild(link)
    //     link.click()
    //     link.remove()
    //     window.URL.revokeObjectURL(url)
    //   })
    // },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    reset() {
      this.warehouseId = ''
      this.referenceNumber = ''
      this.deliveryChargeAmount = 0
      this.billAmount = 0
      this.contactNumber = ''
      this.remarks = ''
      this.statusesPay = ''
      this.status = ''
      this.deliveryChargeAmount = ''
      this.address = ''
      this.paymentStatus = ''
      this.orderStatus = ''
      this.customerName = ''
      this.receiverName = ''
      this.receiverAddress = ''
      this.receiverContactNumber = ''
      this.receiverSecondaryContactNumber = ''
      this.secondaryContactNumber = ''
      this.images = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      }
      this.inventoryInOutDetailList = []
    },
    isNumber(evt) {
      evt = window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
      // $('#shipDate').nepaliDatePicker({
      //   ndpYear: true,
      //   ndpMonth: true,
      //   ndpYearCount: 10,
      //   disableBefore: this.$store.state.startDate,
      //   disableAfter: this.$store.state.endDate,
      //   onChange: () => {
      //     this.shipDate = $('#shipDate').val()
      //   }
      // })
    },
    focusAfterSave() {
      this.$refs.purchaseSalesDate.focus()
    }
  },
  components: {
    Dropdown,
    DatePicker,
    AutoComplete,
    InputNumber,
    InputMask,
    wearhouseDialog,
    FileUpload,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// deliveryEntryForm.vue?066dd7aa